export const dataSources = {
  tis: {
    key: 'TIS',
    label: 'Trane Cloud (TC)',
  },
  fsm: {
    key: 'FSM',
    label: 'Field Service Management (FSM)',
  },
};

export const dataSourceList = Object.values(dataSources);
